<script setup lang="ts">
import { computed, ref, watch } from 'vue'

interface Props {
  value: string | null
  active?: boolean
}

interface Emits {
  (e: 'apply', value: string | null): void
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
})

const emit = defineEmits<Emits>()

const isOpen = ref(false)
const localValue = ref(props.value || '')

const filterIcon = computed(() => {
  return props.active ? 'ri-filter-fill' : 'ri-filter-2-line'
})

watch(() => props.value, newVal => {
  localValue.value = newVal || ''
})

const handleApply = () => {
  emit('apply', localValue.value.trim() || null)
  isOpen.value = false
}
</script>

<template>
  <VMenu
    v-model="isOpen"
    :close-on-content-click="false"
    location="bottom"
    transition="scale-transition"
  >
    <template #activator="{ props: menuProps }">
      <VIconBtn
        v-bind="menuProps"
        variant="plain"
        size="small"
        class="filter-icon-btn ml-1"
        :icon="filterIcon"
        :color="active ? 'primary' : undefined"
      />
    </template>

    <VCard class="pa-4">
      <VTextField
        v-model="localValue"
        autofocus
        placeholder="Точный номер: KP82, KP83"
        hide-details
        width="220px"
        @keyup.enter="handleApply"
      />
      <div class="d-flex justify-end mt-2">
        <VBtn
          size="small"
          variant="outlined"
          color="secondary"
          @click="handleApply"
        >
          Применить
        </VBtn>
      </div>
    </VCard>
  </VMenu>
</template>
